module.exports = __webpack_public_path__ + "img/7.80e041de.svg";